import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'resubscribe-modal',
    templateUrl: './resubscribe-modal.component.html'
})

export class ReSubscribeModalComponent {
    public emailType : string;
    public schoolName : string;

    constructor(
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.emailType = this.route.snapshot.queryParamMap.get('emailType');
        this.schoolName = this.route.snapshot.queryParamMap.get('schoolName');
    }

    gotoEmailPreferences() {
        window.location.href = this.route.snapshot.queryParamMap.get('preferenceLink');
    }
}
